function getValueByPath(obj: { [key: string]: any }, path: string): any {
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
}

export function processEndpoint(
  endpoint: string,
  tokenData: { [key: string]: any },
): string {
  const tokenPattern = /\{([\w.]+)\}/g; // pattern to find field tokens eg {id}, {Parent.OwnerId}, etc

  let replacedString: string = endpoint.replace(
    tokenPattern,
    (match, token) => {
      const replacement = getValueByPath(tokenData, token);

      return replacement !== undefined ? String(replacement) : "0";
    },
  );
  return replacedString;
}
